
        import 'CaptureForm.908eb11.css-module'
        export default {"captureForm":"captureForm_CaptureForm_908eb11"}
    